<div><h1>Saved Searches</h1><template v-if="storySavedSearchesStore.storySavedSearches.length == 0"><div class="alert alert-info">There aren't any saved searches yet</div></template><template v-else><Table></Table></template><hr><p class="text-center text-muted"><a href="/stories">Search for stories</a>
and click the
<span class="btn btn-info btn-xs"><i class="fa fa-search"></i>
Search
<i class="fa fa-caret-down"></i></span>
dropdown button to save new searches</p></div>